import { DetailValue } from 'components/common'
import { getDetailUrl } from 'models/Building/api'


const BuildingValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          {detail?.name || '-'}
        </>
      )}
    />
  );
};


export default BuildingValue
